import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE } from "@/data/site";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-[#08341f] text-white/80 mt-24">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div>
        <div className="flex items-center gap-2.5 mb-4">
          <img src="/logo.png" alt="Next Gen Properties" className="h-11 w-11 object-contain" />
          <span className="font-heading font-bold text-white text-sm leading-tight">NEXT GEN PROPERTIES<br/><span className="text-[#D4AF37] text-[10px] tracking-widest">TELANGANA</span></span>
        </div>
        <p className="text-sm leading-relaxed">Telangana's trusted destination for HMDA, DTCP & FCDA approved premium open plots in prime locations.</p>
      </div>
      <div>
        <h4 className="text-white font-heading font-semibold mb-4">Quick Links</h4>
        <ul className="space-y-2.5 text-sm">
          {[["Projects","/projects"],["About Us","/about"],["Gallery","/gallery"],["Blog","/blog"],["EMI Calculator","/emi-calculator"]].map(([t,u])=>(
            <li key={u}><Link to={u} className="hover:text-[#D4AF37] transition-colors">{t}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-white font-heading font-semibold mb-4">Approvals</h4>
        <ul className="space-y-2.5 text-sm">
          <li>HMDA Approved Layouts</li>
          <li>DTCP Approved Layouts</li>
          <li>FCDA Approved Layouts</li>
          <li>100% Clear Title</li>
        </ul>
      </div>
      <div>
        <h4 className="text-white font-heading font-semibold mb-4">Reach Us</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex gap-2.5"><Phone size={16} className="text-[#D4AF37] shrink-0 mt-0.5"/> {SITE.phone}</li>
          <li className="flex gap-2.5"><Phone size={16} className="text-[#D4AF37] shrink-0 mt-0.5"/> {SITE.phone2}</li>
          <li className="flex gap-2.5"><Mail size={16} className="text-[#D4AF37] shrink-0 mt-0.5"/> {SITE.email}</li>
          <li className="flex gap-2.5"><MapPin size={16} className="text-[#D4AF37] shrink-0 mt-0.5"/> {SITE.address}</li>
          <li className="flex gap-2.5"><Clock size={16} className="text-[#D4AF37] shrink-0 mt-0.5"/> {SITE.hours}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-white/50">
      © {new Date().getFullYear()} Next Gen Properties Telangana. All rights reserved. · <Link to="/login" className="hover:text-[#D4AF37]">Owner Login</Link>
    </div>
  </footer>
);
